import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Modal,
  Row,
  Col,
  Layout,
  Card,
  Select,
  DatePicker,
  Table,
  Collapse,
} from "antd";

import _ from "lodash";
import { ReactSVG } from "react-svg";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getAdminRolesTopic,
  getProjectsSubscriptionTopic,
  getProjectsRequestPublishTopic,
  getBdsEotSubscriptionTopic,
  getRespondersRequestPublishTopic,
} from "hooks/MQTTConstants";
import { useLocation } from "react-router-dom";
import { SocketTopics, UserTopics } from "constants/enums";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import VerticalGraph from "common/Graphs/VerticalGraph";
import useSocketActions from "../../../../hooks/socketActions";
import { generateUUID, popupCenter } from "utils/appUtil";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { formatForRedis, attributeKeyGenerator } from "utils/appUtil";
import { GET_AGGREGATE } from "../../../../reducers/reducer";
import Geocode from "react-geocode";
import { RedoOutlined } from "@ant-design/icons";

import "./Dashboard.scss";

const { Panel } = Collapse;

ChartJS.register(ArcElement, Tooltip, Legend);

const { Option } = Select;
const DriverModal: FC<{
  socket: ISocket;
  params?: any;
  componentUuid?: string;
}> = ({ socket, params, componentUuid }) => {
  const { search } = useLocation();
  const {
    userRequests,
    projects,
    pageAggregateBds,
    selectedPage,
    encrypted_token,
    responders,
  } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [tableDataSource, setTableDataSource] = useState<any>([]);
  const [tableColumns, setTableColumns] = useState<any>([]);
  useState<boolean>(false);
  const [tableHideList, setTableHideList] = useState<any>([]);
  const { getUserRequestPayload } = useSocketActions();
  const [adminRoles, setAdminRoles] = useState<any>(undefined);
  const [userUpdated, setUserUpdated] = useState<any>(undefined);
  const drivers = useRef<any>();
  const [currentLocation, setCurrentLocation] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const timeoutRef = useRef<any>();
  const isMounted = useRef(true);

  const getResponders = (latLng) => {
    setLoading(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getRespondersRequestPublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({
        userId: encrypted_token?.userId,
        latLng,
        height: 300000,
        width: 300000,
      })
    );
  };

  const getMyLocationHandler = () => {
    if (currentLocation && currentLocation?.current) {
      setCurrentLocation({ ...currentLocation });
      return;
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          lat: position?.coords?.latitude,
          lng: position?.coords?.longitude,
          current: true,
        });
        if (isMounted.current) {
          getResponders({
            lat: position?.coords?.latitude,
            long: position?.coords?.longitude,
          });
          if (timeoutRef.current) clearInterval(timeoutRef.current);
          console.log("interval set");
          timeoutRef.current = setInterval(() => {
            console.log("get responders");
            getResponders({
              lat: position?.coords?.latitude,
              long: position?.coords?.longitude,
            });
          }, 10000);
        } else {
          console.log("un mounted");
        }
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  // useEffect(() => {
  // if (adminRoles) {
  // getUsersByRole(adminRoles, "responder");
  // }
  // }, [adminRoles]);

  // useEffect(()=>{
  //   if(encrypted_token){
  //     getMyLocationHandler();
  //   }
  // }, [encrypted_token])

  useEffect(() => {
    if (responders) {
      console.log("responders", responders);
      setLoading(false);
      let sourceData = [];
      let columns: any = [
        {
          title: "Status",
          key: "userStatus",
          dataIndex: "userStatus",
          render: (status: string) => (
            <Button className="beam-btn icon-btn ml-2">
              <ReactSVG
                src="/images/flag-icon.svg"
                className={`${status ?? "gray"}-icon`}
              />
            </Button>
          ),
        },
        {
          title: "Name",
          key: "driverName",
          dataIndex: "driverName",
        },
        {
          title: "Custom id",
          key: "driverCustomId",
          dataIndex: "driverCustomId",
        },
        {
          title: "Email",
          key: "driverEmail",
          dataIndex: "driverEmail",
        },
        {
          title: "Phone",
          key: "driverPhone",
          dataIndex: "driverPhone",
        },
      ];
      responders?.map((x, i) => {
        sourceData.push({
          key: x.id,
          userStatus: x?.status,
          driverName: `${x?.profile?.firstName} ${x?.profile?.lastName}`,
          driverEmail: x?.alternativeIds?.email,
          driverPhone: x?.alternativeIds?.phone,
          driverCustomId: x?.alternativeIds?.customId,
        });
        // socket.subscribeToEvent(
        //   SocketTopics.SubscribePageTopics,
        //   getBdsEotSubscriptionTopic(projects?.userServiceId, x.id.toString()),
        //   (response) => {
        //     console.log("bds eot", response);
        //     setUserUpdated(response);
        //   },
        //   componentUuid
        // );
      });
      drivers.current = sourceData;
      setTableColumns(columns);
      setTableDataSource(sourceData);
    }
  }, [responders]);

  // const getUsersByRole = (roles, type) => {
  //   let userRoles;
  //   switch (type) {
  //     case "dispatcher":
  //       userRoles = roles.filter(
  //         (x: any) =>
  //           x.permissions.indexOf("cad") !== -1 &&
  //           x.permissions.indexOf("admin") === -1
  //       );
  //       break;
  //     case "responder":
  //       userRoles = roles.filter(
  //         (x: any) =>
  //           x.permissions.indexOf("onMove") !== -1 &&
  //           x.permissions.indexOf("admin") === -1
  //       );
  //       break;
  //     case "manager":
  //       userRoles = roles.filter(
  //         (x: any) =>
  //           x.permissions.indexOf("cad") !== -1 &&
  //           x.permissions.indexOf("onMove") !== -1 &&
  //           x.permissions.indexOf("admin") === -1
  //       );
  //       break;
  //   }
  //   const rolesQuery = userRoles.map((y: any) => {
  //     return `@roleId === '${y._id}'`;
  //   });
  //   const userRequest: any = {
  //     select: {
  //       index: {
  //         searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
  //         searchQuery: `@serviceId:{'${formatForRedis(
  //           projects?.userServiceId
  //         )}'}`,
  //         searchOptions: "TIMEOUT 5000",
  //       },
  //       load: {
  //         id: "$.objectId",
  //         status: "$.nonpersistent.static.live.status",
  //         live: "$.persistent.static.live",
  //         roleId: "$..admin.profile.roleId",
  //       },
  //     },
  //     apply: {
  //       expression: "",
  //       name: "",
  //     },
  //     result: {},
  //     filter: {
  //       expression: `exists(@roleId) && (${rolesQuery.join("||")})`,
  //     },
  //     anyStatus: false,
  //   };
  //   dispatch(
  //     GET_AGGREGATE({
  //       requestData: userRequest,
  //       callback: (response) => {
  //     let sourceData = [];
  //     let columns: any = [
  //       {
  //         title: "Status",
  //         key: "userStatus",
  //         dataIndex: "userStatus",
  //         render: (status: string) => (
  //           <Button className="beam-btn icon-btn ml-2">
  //             <ReactSVG
  //               src="/images/flag-icon.svg"
  //               className={`${status ?? "gray"}-icon`}
  //             />
  //           </Button>
  //         ),
  //       },
  //       {
  //         title: "Name",
  //         key: "driverName",
  //         dataIndex: "driverName",
  //       },
  //       {
  //         title: "Custom id",
  //         key: "driverCustomId",
  //         dataIndex: "driverCustomId",
  //       },
  //       {
  //         title: "Email",
  //         key: "driverEmail",
  //         dataIndex: "driverEmail",
  //       },
  //       {
  //         title: "Phone",
  //         key: "driverPhone",
  //         dataIndex: "driverPhone",
  //       },
  //     ];
  //     response?.map((x, i) => {
  //       sourceData.push({
  //         key: x.id,
  //         userStatus: x?.status?.name,
  //         driverName: `${x?.live?.profile?.firstName} ${x?.live?.profile?.lastName}`,
  //         driverEmail: x?.live?.alternativeIds?.email,
  //         driverPhone: x?.live?.alternativeIds?.phone,
  //         driverCustomId: x?.live?.alternativeIds?.customId,
  //       });
  //       socket.subscribeToEvent(
  //         SocketTopics.SubscribePageTopics,
  //         getBdsEotSubscriptionTopic(
  //           projects?.userServiceId,
  //           x.id.toString()
  //         ),
  //         (response) => {
  //           console.log("bds eot", response);
  //           setUserUpdated(response);
  //         },
  //         componentUuid
  //       );
  //     });
  //     drivers.current = sourceData;
  //     setTableColumns(columns);
  //     setTableDataSource(sourceData);
  //   },
  // })
  //   );
  // };

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      console.log("clear timeput");
      if (timeoutRef.current) {
      }
      clearInterval(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (userUpdated) {
      const { pattern, data } = userUpdated;
      const userId = pattern?.split("/")?.[4];
      let tempSource = [...tableDataSource];
      const userIdx = tempSource.findIndex((user) => {
        return user?.key?.toString() === userId;
      });
      if (userIdx !== -1) {
        const output: any = {};
        let current;
        for (let op of data) {
          current = output;
          let segments = op.path.split("/");
          segments.map((segment, index) => {
            if (segment !== "") {
              if (!(segment in current)) {
                if (index + 1 === segments.length) {
                  current[segment] = op.value;
                } else {
                  current[segment] = {};
                }
              }
              current = current[segment];
            }
          });
        }
        if (output?.nonpersistent?.static?.live?.status?.name) {
          tempSource[userIdx].userStatus =
            output?.nonpersistent?.static?.live?.status?.name;
          setTableDataSource(tempSource);
        }
      }
      let columns: any = [
        {
          title: "Status",
          key: "userStatus",
          dataIndex: "userStatus",
          render: (status: string) => (
            <Button className="beam-btn icon-btn ml-2">
              <ReactSVG
                src="/images/flag-icon.svg"
                className={`${status ?? "gray"}-icon`}
              />
            </Button>
          ),
        },
        {
          title: "Name",
          key: "driverName",
          dataIndex: "driverName",
        },
        {
          title: "Custom id",
          key: "driverCustomId",
          dataIndex: "driverCustomId",
        },
        {
          title: "Email",
          key: "driverEmail",
          dataIndex: "driverEmail",
        },
        {
          title: "Phone",
          key: "driverPhone",
          dataIndex: "driverPhone",
        },
      ];
      setTableColumns(columns);
    }
  }, [userUpdated]);

  useEffect(() => {
    if (encrypted_token) {
      // const query = new URLSearchParams(search);
      // const userId = query.get("userId");
      // const connectionId = query.get("connectionId");
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(encrypted_token?.connectionId),
        (response) => {
          const tempProject = response?.response?.data?.projects;
          // getAdminRoles(tempProject?.adminUserId, tempProject?.userServiceId);
        },
        componentUuid
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
        })
      );

      getMyLocationHandler();
    }
  }, [encrypted_token]);

  return (
    <React.Fragment>
      <Row gutter={20} className="scrollable-table" style={{ display: "grid" }}>
        <Col
          xs={24}
          sm={24}
          md={24}
          style={{ maxHeight: 1000, overflow: "scroll" }}
        >
          {/* <Button
            className="beam-btn icon-btn"
            style={{
              float: "right",
              margin: "10px 10px 10px 0",
            }}
            loading={loading}
            onClick={() => {
              // setProjectFilterLoading(true);
              // searchPage();
              getResponders({lat: currentLocation.lat, long: currentLocation.long});
            }}
          >
            {!loading &&
              <RedoOutlined />
            }
          </Button> */}

          <Table
            dataSource={tableDataSource}
            className={tableDataSource?.length > 0 ? "" : "table-empty"}
            onRow={(record) => {
              return {
                onDoubleClick: () => {
                  console.log("on double click row", record);
                },
                onClick: () => {},
              };
            }}
            columns={tableColumns}
            // columns={tableColumns}
            scroll={{ x: true }}
            onChange={(e) => {
              console.log("event here", e);
            }}
            rowClassName={(record, index) => {
              if (record?.key === selectedPage?.page?.pageId)
                return "row-selected";
              return "";
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default DriverModal;
